import React from 'react';

export const Flag = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
	<svg viewBox="0 0 80 80" {...props}>
		<g fillRule="evenodd" stroke="none" strokeWidth="1">
			<path d="M48.398 42.378a2.024 2.024 0 01-2.02-2.021V21.82a6.022 6.022 0 002.02.348h16.434l-5.99 8.984a2.023 2.023 0 000 2.242l5.99 8.984H48.398zm-6.062-4.042H26.168V14.084h14.146c1.115 0 2.022.907 2.022 2.02v22.232zM18.084 70.94V12.063c0-1.114.906-2.021 2.021-2.021 1.114 0 2.021.907 2.021 2.02v58.879h-4.042zm44.87-38.668l7.336-11.005c.894-1.342-.072-3.142-1.682-3.142h-20.21a2.023 2.023 0 01-2.02-2.02v-.001a6.07 6.07 0 00-6.064-6.063H25.82A6.074 6.074 0 0020.105 6a6.07 6.07 0 00-6.063 6.063V70.94H10v4.042h20.21V70.94h-4.042V42.378h16.515a6.072 6.072 0 005.715 4.042h20.21c1.613 0 2.575-1.802 1.682-3.142l-7.337-11.005z" />
		</g>
	</svg>
);
